import React from 'react';
import { observer } from 'mobx-react';
import '../../../../css/_decisionOverlay.scss';
import { useTranslation, Trans } from 'react-i18next';
import { FlexDiv } from '../../../design-system/containers';
import { TextDefault } from '../../../design-system/texts';
import { palette } from '../../../design-system/colors';
import { rgba } from 'polished';
import { Heading3 } from '../../../design-system/headings';
import { CheckCircle, CancelCircle } from '../decisionSubjectFeedbackIcons';
import { ThemedButton } from '../../../themed/themed-button/ThemedButton';

export const DecisionFeedback = observer(
    ({ subject, showAnswerVideo, tryAgain }) => {
        const {
            numberOfRightAnswers,
            numberOfPossibleDecisions = 1,
            decisionFeedbackTable,
        } = subject;

        const userDidAnswerCorrectly =
            numberOfRightAnswers / numberOfPossibleDecisions === 1;
        const { t } = useTranslation();

        return (
            <>
                <FlexDiv
                    positionAbsolute
                    justifyCenter
                    alignCenter
                    zIndex={2}
                    fullWidth
                    fullHeight
                >
                    <FlexDiv
                        backgroundColor={rgba(palette.graphite.white, 0.9)}
                        justifyCenter
                        alignCenter
                        padding={16}
                        column
                        gap={24}
                        borderRadius={8}
                        fullWidth
                        maxWidth={444}
                        mx={48}
                        pt={32}
                        pb={24}
                    >
                        <Heading3>
                            {userDidAnswerCorrectly
                                ? t('decisionSubjectFeedbackTitlePositive')
                                : t('decisionSubjectFeedbackTitleImprovable')}
                        </Heading3>
                        <FlexDiv gap={16}>
                            {decisionFeedbackTable.map((decision) => (
                                <>
                                    {decision.decision_1.key ===
                                        decision.answer &&
                                        (decision.decision_1.correct ? (
                                            <CheckCircle
                                                color={palette.evergreen.aspargus}
                                                big
                                            />
                                        ) : (
                                            <CancelCircle
                                                color={palette.vibrant.red}
                                                big
                                            />
                                        ))}
                                    {decision.decision_2.key ===
                                        decision.answer &&
                                        (decision.decision_2.correct ? (
                                            <CheckCircle
                                                color={palette.evergreen.aspargus}
                                                big
                                            />
                                        ) : (
                                            <CancelCircle
                                                color={palette.vibrant.red}
                                                big
                                            />
                                        ))}
                                </>
                            ))}
                        </FlexDiv>

                        <FlexDiv gap={16} desktopOnly column alignCenter>
                            <FlexDiv column alignCenter>
                                <Trans
                                    components={{
                                        p: <TextDefault />,
                                        b: <TextDefault bold />,
                                    }}
                                >
                                    {t('decisionSubjectFeedbackInfo', {
                                        count: numberOfRightAnswers,
                                        numberOfRightAnswers,
                                        numberOfPossibleDecisions,
                                    })}
                                </Trans>
                                <TextDefault>
                                    {' '}
                                    {userDidAnswerCorrectly
                                        ? t(
                                              'decisionSubjectFeedbackCommentPositive'
                                          )
                                        : t(
                                              'decisionSubjectFeedbackCommentImprovable'
                                          )}
                                </TextDefault>
                            </FlexDiv>
                            <FlexDiv gap={24}>
                                <ThemedButton
                                    mode={!userDidAnswerCorrectly ? 'primary' : 'secondary'}
                                    onClick={tryAgain}
                                    text={t('tryAgain')}
                                >
                                </ThemedButton>
                                <ThemedButton
                                    mode="secondary"
                                    text={t('previewVideo')}
                                    onClick={showAnswerVideo}
                                >
                                </ThemedButton>
                            </FlexDiv>
                        </FlexDiv>
                    </FlexDiv>
                </FlexDiv>
            </>
        );
    }
);
